import React from 'react';
import css from './index.module.scss';

const ContrastTable: React.FC = () => {
    const prosAndConsContent1 = [
        {
            title: 'Expertise:',
            desc: 'Our certified licensed electricians ensure top-notch installation services.',
        },
        {
            title: 'Comprehensive Service:',
            desc: 'Enjoy full-process support from order placement to installation completion, guaranteeing a seamless experience.',
        },
    ];

    const prosAndConsContent2 = [
        {
            title: 'Affordability:',
            desc: 'Save approximately $1000 compared to standard licensed electrician rates.',
        },
        {
            title: 'Time-Saving:',
            desc: 'Avoid the hassle of finding an electrician yourself.',
        },
        {
            title: 'Expertise:',
            desc: 'Our certified licensed electricians provide top-notch installation services.',
        },
        {
            title: 'Comprehensive Service:',
            desc: 'Experience seamless support from order placement to installation completion.',
        },
        {
            title: 'Quick Installation:',
            desc: 'Benefit from a short installation period.',
        },
    ];

    const prosAndConsContent3 = [
        {
            title: 'Installation Accuracy:',
            desc: 'The quality of installation may vary, potentially leading to additional costs and time if issues arise.',
        },
        {
            title: 'Licensing:',
            desc: 'Ensure the electrician is properly licensed to avoid potential risks and non-compliance.',
        },
        {
            title: 'Installation Timeline:',
            desc: 'The completion time for installation can be unpredictable and may not always align with customer expectations.',
        },
        {
            title: 'Cost Variability:',
            desc: 'Costs can fluctuate based on the electrician’s rates and any unforeseen complications.',
        },
    ];

    return (
        <section className={css.ContrastTable} id="SHP2_CONTRAST">
            <div className="contrast-container">
                <table className="product-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <div className="discolor-text">EcoFlow Installation Consulting Service</div>
                                <span className="desc">（The service is included by default in the order of the purchased SHP2&SHP2 bundle）</span>
                            </th>
                            <th>
                                <div className="discolor-text">EcoFlow Installation Service</div>
                            </th>
                            <th>
                                <div className="discolor-text">Other Services on the Market</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="discolor-text">Service Program</td>
                            <td className="title">Pay after Consulting</td>
                            <td className="title">Pay before Consulting</td>
                            <td className="title">Pay after Consulting</td>
                        </tr>
                        <tr>
                            <td className="discolor-text">Payment to</td>
                            <td className="title">EcoFlow Certified Electrician</td>
                            <td className="title">EcoFlow Official Website</td>
                            <td className="title">Non-EcoFlow Certified Electrician on the market</td>
                        </tr>
                        <tr>
                            <td className="discolor-text">Service Area</td>
                            <td className="title">All of the USA</td>
                            <td className="title">All of the USA</td>
                            <td className="title">Customer Dependent</td>
                        </tr>
                        <tr>
                            <td className="discolor-text">Basic Service Costs</td>
                            <td className="title">$2000-$2500 + Free Consulting Fee</td>
                            <td className="title">$2000</td>
                            <td className="title">$3000+</td>
                        </tr>
                        <tr>
                            <td className="discolor-text">Pros and Cons </td>
                            <td className="more-text-box">
                                {prosAndConsContent1.map((item: any, index: number) => (
                                    <div className="more-text-item" key={index.toString()}>
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                ))}
                            </td>
                            <td className="more-text-box">
                                {prosAndConsContent2.map((item: any, index: number) => (
                                    <div className="more-text-item" key={index.toString()}>
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                ))}
                            </td>
                            <td className="more-text-box">
                                {prosAndConsContent3.map((item: any, index: number) => (
                                    <div className="more-text-item" key={index.toString()}>
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                ))}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default ContrastTable;
